import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PartnerDto, SchoolBillDto } from '../../api/models';
import { AngularDeviceInformationService } from 'angular-device-information';
import { QRCodeComponent } from 'angularx-qrcode';
import * as bootstrap from 'bootstrap';
import { ReceiptControllerService, SchoolBillControllerService } from '../../api/services';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { SessionService } from '../../common/session.service';
import { constants, PaymentNetwork } from '../../common/constants';

@Component({
  selector: 'app-cashier-school-payment-anticipation',
  imports: [ReactiveFormsModule, QRCodeComponent],
  templateUrl: './school-payment-anticipation.component.html',
  styleUrl: './school-payment-anticipation.component.css',
})
export class SchoolPaymentAnticipationComponent implements OnInit {

  listMois = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  message: string = '';
  isBill: boolean = true;
  isPayment: boolean = false;
  formBill: FormGroup;
  formPayment: FormGroup;
  student?: SchoolBillDto;
  isWallet: boolean = false;
  fees: number = 0;
  taxe: number = 0;
  paymentNetwork: PaymentNetwork | undefined;
  paymentNetworkOtpion: string = '';
  qrCode: string = '';
  isDesktop: boolean = false;
  connectedSchool?: PartnerDto;
  idSchool: number = 0;
  amount: number = 0;
  mminAmount = 0;
  processing = false;
  paymentMeans: PaymentNetwork[] = [];

  constructor(
    builder: FormBuilder,
    private deviceInfo: AngularDeviceInformationService,
    private billService: SchoolBillControllerService,
    private receiptService: ReceiptControllerService,
    private sessionService: SessionService,
    private route: Router,
    private activeRoute: ActivatedRoute
  ) {
    this.formBill = builder.group({
      idStudent: ['', [Validators.required]],
    });
    this.formPayment = builder.group({
      school: ['', [Validators.required]],
      idStudent: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      echeances: builder.array(this.listMois.map(() => builder.control(false))),
      phone: ['']
    });
    this.isDesktop = this.deviceInfo.isDesktop();
    this.mminAmount = environment.MIN_AMOUNT_SCHOOL_PAYMENT;
     this.paymentMeans= constants.getPaymentNetworks(environment.codeCountry, 'cashier');
  }

  ngOnInit(): void {
    const sess = this.sessionService.getSessionInfo();
    if (sess.partner?.type == 'MERCHANT') {
      this.connectedSchool = sess.partner;
      this.idSchool = sess.partner?.id!!;
    }

    this.activeRoute.params.subscribe(p => {
      if (p['idStudent']) {
        this.formBill.patchValue({
          idStudent: p['idStudent']
        });
        this.findStudent();
      }
    });
  }

  getAmount() {
    if (this.formPayment.value.amount) {
      this.amount = this.formPayment.value.amount;
    }
  }

  findStudent() {
    if (!this.idSchool) {
      this.message = "Aucun établissement associé à votre compte";
      const elt = document.getElementById('modErrPay');
      const modAdd = new bootstrap.Modal(elt!!);
      modAdd.show();
      return;
    }

    this.billService.findStudent(
      this.formBill.value.idStudent,
      this.idSchool
    ).subscribe(
      {
        next: (resp) => {
          if (resp.amount && resp.amount > 0) {
            this.message = 'Vous avez des arriérés de paiement, veuillez regler ces arriérés avant de pouvoir payer par anticipation';
            const elt = document.getElementById('modErrPay');
            const modAdd = new bootstrap.Modal(elt!!);
            modAdd.show();
          } else {
            this.student = resp;
            this.formPayment.patchValue({
              school: this.idSchool,
              idStudent: this.formBill.value.idStudent
            });
            this.isBill = false;
            this.isPayment = true;
          }
        },
        error: (err) => {
          this.message = err.error.message;
          const elt = document.getElementById('modErrPay');
          const modAdd = new bootstrap.Modal(elt!!);
          modAdd.show();
        }
      }
    );
  }

  getEcheances() {
    let echeances: boolean[] = this.formPayment.value.echeances;
    return this.listMois.filter((m, i) => echeances[i]);
  }

  processPayment() {
    this.processing = true;
    this.billService.payAnticipated1({
      idBill: 0,
      amount: this.formPayment.value.amount,
      idSchool: this.formPayment.value.school,
      idStudent: this.formPayment.value.idStudent,
      paymentNetwork: this.paymentNetwork?.code!,
      paymentMean: this.formPayment.value.phone,
      echeances: this.getEcheances()
    }).subscribe(
      {
        next: (resp) => {
          this.processing = false;
          if (this.paymentNetwork?.code.toUpperCase() == 'CARD') {
            this.openUrl(resp.paymentUrl ?? '');
          } else {
            this.isPayment = false;
            this.isBill = false;
            this.qrCode = resp.paymentUrl ?? '';
            this.finalizePayment(resp.reference!!);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.processing = false;
          this.message = err.error.message;
          const elt = document.getElementById('modErrPay');
          const modAdd = new bootstrap.Modal(elt!!);
          modAdd.show();
        }
      });
  }

  isValid() {
    let valid = this.formPayment.valid;
    console.log('form valid '+this.formPayment.value);
    if (this.paymentNetwork && !this.paymentNetwork.isMobileMoney) {
      valid = valid && true;
    } else {
      let phone = this.formPayment.value.phone;
      valid = valid && phone != null && phone.length >= 9;
      if (this.paymentNetwork?.code.toUpperCase() == 'OMSN') {
        this.paymentNetworkOtpion = 'maxit';
      }
    }
    return valid;
  }

  completeForm(network: PaymentNetwork) {
    this.formBill.reset();
    this.paymentNetwork = network;
    const methods = document.querySelectorAll('.payment-method');

    if (this.paymentNetwork && !this.paymentNetwork?.isMobileMoney) {
      this.isWallet = false;
    } else {
      this.isWallet = true;
    }

    methods.forEach(element => {
      if (element.getAttribute('data-method') == this.paymentNetwork?.code) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });
  }

  onSelectPaymentMethod(network: PaymentNetwork) {
    this.billService.getFeesAndTaxes1({
      idBill: 0,
      amount: this.formPayment.value.amount,
      idSchool: this.formPayment.value.school,
      idStudent: this.formPayment.value.idStudent,
      paymentMode: network.code
    }).subscribe(
      {
        next: (resp) => {
          this.taxe = resp.taxes;
          this.fees = resp.fees - this.taxe;
          this.completeForm(network);
        },
        error: (err) => {
          this.message = err.error.message;
          const elt = document.getElementById('modErrPay');
          const modAdd = new bootstrap.Modal(elt!!);
          modAdd.show();
        }
      }
    );
  }

  openUrl(url: string) {
    window.open(url, '_self');
  }

  async finalizePayment(reference: string) {
    this.receiptService.getPaymentDetails(
      reference
    ).subscribe({
      next: (resp) => {
        if (resp.status == 'PENDING') {
          setTimeout(() => {
            this.finalizePayment(reference);
          }, 20000);
        } else {
           this.route.navigateByUrl('/cashier/receipt/' + reference);
        }
      },
    });
  }
}
